import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';

import accountabilityTemplateSaga from './api/accountability-template/accountability-template.saga';
import administrationSaga from './api/administration/administration.saga';
import approvalSaga from './api/approval/approval.saga';
import badgeSaga from './api/badge/badge.saga';
import collectionSaga from './api/collection/collection.saga';
import commentSaga from './api/comment/comment.saga';
import deviceAssignmentSaga from './api/device-assignment/device-assignment.saga';
import documentSaga from './api/document/document.saga';
import emailTemplateSaga from './api/email-template/email-template.saga';
import externalRegistrationSaga from './api/external-registration/external-registration.saga';
import leaderboardSaga from './api/leaderboard/leaderboard.saga';
import loginSaga from './api/login/login.saga';
import memberBadgeSaga from './api/member/badges/member-badge.saga';
import memberSaga from './api/member/member.saga';
import notificationSaga from './api/notification/notification.saga';
import pushNotificationSaga from './api/notification/push/push-notification.saga';
import pollSaga from './api/poll/poll.saga';
import postSaga from './api/post/post.saga';
import programmeTeamsSaga from './api/programme-teams/programme-teams.saga';
import programmeSaga from './api/programme/programme.saga';
import v2programmeSaga from './api/programme/v2/programme.saga';
import reactionSaga from './api/reaction/reaction.saga';
import registrationSaga from './api/registration/registration.saga';
import resourceSaga from './api/resource/resource.saga';
import supportTemplateSaga from './api/support-template/support-template.saga';
import supportSaga from './api/support/support.saga';
import surveySaga from './api/survey/survey.saga';
import systemUserSaga from './api/system-user/system-user.saga';
import teamMemberSaga from './api/team-member/team-member.saga';
import teamSaga from './api/team/team.saga';
import trackedSessionDashboardSaga from './api/tracked-session-dashboard/tracked-session-dashboard.saga';
import tribeTemplateSaga from './api/tribe-template/tribe-template.saga';

import BadgeReducer from './slices/badge/badge.slice';
import AccountabilityReducer from './slices/programme/accountability/accountability.slice';
import MemberReducer from './slices/programme/member/member.slice';
import PlanReducer from './slices/programme/plan/plan.slice';
import ProgrammeReducer from './slices/programme/programme.slice';
import SupportReducer from './slices/programme/support/support.slice';
import TeamReducer from './slices/programme/team/team.slice';
import TribeReducer from './slices/programme/tribe/tribe.slice';
import RegistrationReducer from './slices/registration/registration.slice';
import SystemReducer from './slices/system/system.slice';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    system: SystemReducer,
    programme: ProgrammeReducer,
    plan: PlanReducer,
    accountability: AccountabilityReducer,
    support: SupportReducer,
    member: MemberReducer,
    tribe: TribeReducer,
    registration: RegistrationReducer,
    team: TeamReducer,
    badge: BadgeReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(sagaMiddleware)
});

sagaMiddleware.run(loginSaga);
sagaMiddleware.run(programmeSaga);
sagaMiddleware.run(collectionSaga);
sagaMiddleware.run(resourceSaga);
sagaMiddleware.run(accountabilityTemplateSaga);
sagaMiddleware.run(supportTemplateSaga);
sagaMiddleware.run(memberSaga);
sagaMiddleware.run(memberBadgeSaga);
sagaMiddleware.run(tribeTemplateSaga);
sagaMiddleware.run(systemUserSaga);
sagaMiddleware.run(documentSaga);
sagaMiddleware.run(emailTemplateSaga);
sagaMiddleware.run(leaderboardSaga);
sagaMiddleware.run(supportSaga);
sagaMiddleware.run(postSaga);
sagaMiddleware.run(reactionSaga);
sagaMiddleware.run(commentSaga);
sagaMiddleware.run(administrationSaga);
sagaMiddleware.run(approvalSaga);
sagaMiddleware.run(notificationSaga);
sagaMiddleware.run(pollSaga);
sagaMiddleware.run(registrationSaga);
sagaMiddleware.run(externalRegistrationSaga);
sagaMiddleware.run(teamSaga);
sagaMiddleware.run(teamMemberSaga);
sagaMiddleware.run(programmeTeamsSaga);
sagaMiddleware.run(badgeSaga);
sagaMiddleware.run(pushNotificationSaga);
sagaMiddleware.run(surveySaga);
sagaMiddleware.run(v2programmeSaga);
sagaMiddleware.run(deviceAssignmentSaga);
sagaMiddleware.run(trackedSessionDashboardSaga);
